import { COUNTRY_DATA } from "../constant";

export const setCountry = data => {
    return {
      type: COUNTRY_DATA.SET_COUNTRY_FROM_API,
      payload: data,
    };
  };